import * as React from "react";
import {
  ActivityFragment,
  UserMinimalFragment,
} from "../../../graphql/fragments";
import { CompanyMinimalFragment } from "../../../graphql/fragments/Company";
import useTranslations from "../../../hooks/useTranslations";
import { Link } from "../../wombat-ui";
import Avatar from "../../wombat-ui/Avatar";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type UserUpdatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: UserMinimalFragment;
};

interface UserUpdatedActivityProps {
  activity: UserUpdatedActivity;
}

export function isUserUpdatedActivity(
  q: ActivityFragment
): q is UserUpdatedActivity {
  return q.key === "user.updated";
}

export const UserUpdatedActivity: React.FC<UserUpdatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();
  const { trackable } = activity;

  return (
    <Activity
      activity={activity}
      id="userUpdatedActivity"
      visual={
        <Avatar
          src={trackable.avatar}
          alt={`${trackable.name} avatar`}
          type="user"
          size={10}
        />
      }
    >
      <Span className="text-sm">
        {t("activity.labels.userUpdated", {
          user: (
            <Link to={`/users/${activity.trackable.slug}`} key={activity.id}>
              {activity.trackable.name}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
